import { useEffect, useMemo } from 'react'

import { useGrowthBook } from '@growthbook/growthbook-react'
import { getVisitorUuid } from '@infrastructure/Utils/VisitorUtils/GetVisitorUuid'

export const useSetVisitorUuidAttributes = (): null => {
    const growthbook = useGrowthBook()
    const visitorUuid = useMemo(() => getVisitorUuid(), [])

    useEffect(() => {
        if (!growthbook || !visitorUuid) return

        growthbook.setAttributes({
            ...growthbook.getAttributes(),
            id: visitorUuid,
        })
    }, [growthbook, visitorUuid])

    return null
}
